import { render } from "./product-stock-message.vue?vue&type=template&id=178b7fbc"
import script from "./product-stock-message.vue?vue&type=script&lang=js"
export * from "./product-stock-message.vue?vue&type=script&lang=js"

import "./product-stock-message.vue?vue&type=style&index=0&id=178b7fbc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__